export class Attestation {
  header!: string;
  attestation!: string;
  sections!: Array<{
    header: string;
    paragraphs: Array<string>;
  }>;
  confirmationText!: string;
}
